window.NPS = window.NPS || {};
window.NPS.Views = window.NPS.Views || {};
window.NPS.Views.LinkEdit = window.NPS.Views.LinkEdit || {};

window.NPS.Views.LinkEdit.create = (function($, _) {

    function link() {
        this.building = {};
        this.options = {};
        this.attributes = {};
    }
    link.prototype.setProperties = function setLinkProperties(properties) {
        this.building = _.extend(this.building, properties);
    }
    link.prototype.setProperty = function setLinkProperty(propertyName, propertyValue) {
        this.building[propertyName] = propertyValue;
    }
    link.prototype.getProperty = function getLinkProperty(propertyName) {
        return this.building[propertyName];
    }

    link.prototype.setOptions = function setLinkOptions(options) {
        this.options = _.extend(this.options, options);
    }
    link.prototype.setOption = function setLinkOption(opt, val) {
        this.options[opt] = val;
    }
    link.prototype.getOption = function getLinkOption(optionName) {
        return this.options[optionName];
    }

    link.prototype.setAttribute = function setLinkAttribute(attr, val) {
        this.attributes[attr] = val;
    }
    link.prototype.getAttribute = function getLinkAttribute(attr) {
        return this.attributes[attr];
    }
    link.prototype.getAttributes = function getLinkAttributes() {
        return this.attributes;
    }

    function editor(el, opts) {
        var
            $el = $(el),
            self = this,
            opts = _.defaults({}, opts)
        ;
        this.$el = $el;
        this.el = $el.get(0);

        opts.root = opts.root || '.';

        this.opts = opts;
        this.path = opts.root + '/edition/editors/links/';
        this.data = opts.data || {};
        this.site = opts.data.site;

        this.link = new link();
        this.link.setProperties(opts.data);
        this.stage = null;
        this.view = null;
    }

    editor.prototype.$ = function (sp) {
        return this.$el.find(sp);
    };
    editor.prototype.interpolate = function (val) {
        var link = this.link;
        val = val.replace(/\[(\w+)\]/, function (str, p) { return link.getProperty(p); });
        return val;
    };
    editor.prototype.show = function () {
        var self = this,
            $el = this.$el.show(),
            $modal = $el.closest('.nps-modal')
        ;

        self.load('index').then(function() {
            $modal.addClass('is-visible');
        });


        // mise en place de la fenêtre modale
        if (!$modal.length) {
            $el.wrap("<div class='nps-modal'></div>");
            $modal = $el.closest('.nps-modal');
        }
        $modal.off();
        $modal.on('click mousedown mouseup', function(e) {
            e.stopPropagation();
        });

        // mise en place des événements globaux de l'éditeur
        // bouton précédent
        $el.on('click.npseditorlinks', '[data-action="previous"]', function() {
            self.goPrevious();
        });
        // bouton suivant
        $el.on('click.npseditorlinks', '[data-action="next"]', function() {
            self.goNext();
        });
        // bouton de fermeture
        $el.on('click.npseditorlinks', '.closer', function() {
            self.hide();
        });

        return this;
    };
    editor.prototype.hide = function () {
        this.$el
            .hide()
            .off('.npseditorlinks')
            .empty()
            .closest('.nps-modal').removeClass('is-visible')
        ;
        return this;
    };
    editor.prototype.enableNext = function (stage) {
        this.$el.find('[data-page="'+ stage +'"] .step-next').removeClass('ExternalButtonDisabled');
        return this;
    };

    editor.prototype.load = function (page, data) {
        var self = this, $el = self.$el;

        data = _.defaults({}, data, self.data, {gsite: self.data.site || self.site});

        if (self.view) {
            self.view.unstage();
            self.view = null;
        }

        var params = Object.assign({}, data)
        delete params.srchref;

        return $.get(this.path + page + '.htm', params).then(function(resp) {
            self.stage = page;
            $el.html(resp);
            return self;
        }).then(function() {
            var creator = window.NPS.Views.LinkEdit.Views[page];
            self.view = creator(self, {root: self.opts.root, path: self.path, data: data}).stage();
            return self;
        });
    };


    var contentLoad = function(obj) {
        var modes = {
            i: function() {
                return obj.load('select/internal', {documentId: obj.link.getProperty('fromDocument')});
            },
            p: function() {
                return obj.load('select/document', {structure: obj.link.getProperty('structure')});
            },
            u: function() {
                return obj.load('select/module');
            },
            l: function() {
                return obj.load('select/library', {libraryId: obj.link.getProperty('library')});
            },
            e: function() {
                return obj.load('select/extended', {extension: obj.link.getProperty('extension')});
            }
        };
        var mode = obj.link.getProperty('content');
        return mode && modes[mode] && modes[mode]();
    };

    var nextIndexLoad = function(obj) {
        var modes = {
            m: function() {
                obj.complete();
            },
            e: function() {
                obj.complete();
            },
            h: function() {
                obj.load('parameters', {linker: 'external', source: 'external', mode: 'default'});
            }
        };
        var mode = obj.link.getProperty('content');

        if (contentLoad(obj)) return;
        return mode && modes[mode] && modes[mode]();
    };

    editor.prototype.goPrevious = function () {
        switch (this.stage) {
            case 'select/document':
                this.load('index');
            break;
            case 'select/module':
                this.load('index');
            break;
            case 'select/library':
                this.load('index');
            break;
            case 'select/extended':
                this.load('index');
            break;
            case 'parameters':
                if (!contentLoad(this)) {
                    this.load('index');
                }
            break;
        }
    };
    editor.prototype.goNext = function () {
        this.view.commit();

        switch (this.stage) {
            case 'index':
                nextIndexLoad(this);
            break;
            case 'select/document':
                this.load('parameters', {linker: 'documents', source: this.link.getProperty('structure'), mode: this.link.getProperty('displayMode')});
            break;
            case 'select/module':
                this.load('parameters', {linker: 'monikers', source: this.link.getProperty('source'), mode: this.link.getProperty('displayMode')});
            break;
            case 'select/library':
                this.load('parameters', {linker: 'libraries', source: this.link.getProperty('library'), mode: this.link.getProperty('displayMode')});
            break;
            case 'select/extended':
                this.complete();
            break;
            case 'parameters':
                this.complete();
            break;
        }
    };
    editor.prototype.complete = function () {
        var url = this.link.getProperty('link'),
            qs = this.link.getProperty('querystring')
        ;

        url = url.replace('[pack]', this.link.getProperty('pack'));
        if (qs) {
            qs = qs.trim();
            qs = qs.replace(/^\?/, '');
            qs = qs.replace(/^&/, '');
            if (url.indexOf('?') !== -1) {
                url+= '&'+qs;
            } else {
                url+= '?'+qs;
            }
        }
        this.link.setProperty('link', url);

        var descriptorElements = [];
        descriptorElements.push(this.link.getProperty('content'));
        switch (this.link.getProperty('content')) {
            case 'u' :
                descriptorElements.push(this.link.getProperty('site'), this.link.getProperty('moniker'));
                break;
            case 'p' :
                descriptorElements.push(this.link.getProperty('documentId'), this.link.getProperty('anchorId'));
                break;
            case 'l' :
                descriptorElements.push(this.link.getProperty('leafId'), this.link.getProperty('nodeId'));
                var ref = this.link.getProperty('reference');
                if (ref) {
                    descriptorElements.push(ref);
                }
                break;
            default :
                descriptorElements.push(this.link.getProperty('node'), this.link.getProperty('elementId'));
        }


        var oLinkInfo={
            raw: this.link.getProperty('link'),
            url: url,
            descriptor: descriptorElements.join(':'),
            target: this.link.getProperty('target') || '',
            relationship: this.link.getOption('rel')  || '',
            title:  this.link.getOption('title') || '',
            customAttributes:  this.link.getAttributes()
        };

        this.opts.done && this.opts.done(oLinkInfo);
        this.hide();
    };

    return function(el, opts) {
        return new editor(el, opts);
    };

})(window.jQuery, window._);